(() => {
  const angular = window.angular;

  angular.module('app').config(ReportRouter);

  ReportRouter.$inject = ['$stateProvider'];

  function ReportRouter($stateProvider) {
    $stateProvider
      .state('member.customer.show.project.forensicLicensePlates', {
        url: '/forensic-license-plates',
        component: 'forensicLicensePlates',
        redirectTo: 'member.customer.show.project.forensicLicensePlates.search',
        authenticated: true,
        resolve: {
          module: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + `/css/forensic-license-plates.style-${style}.css`,
                window.assetsPath + '/js/vendors/gmap-vendors.min.js',
                window.assetsPath + '/js/app/forensic-analysis.module.min.js',
                window.assetsPath + '/js/app/forensic-license-plate.module.min.js',
              ]);
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"modules.forensic-license-plate.breadcrumb" | translate}}',
        },
      })
      .state('member.customer.show.project.forensicLicensePlates.search', {
        url: '/search',
        template: `<new-front-container path="'license-plates/search'"></new-front-container>`,
        authenticated: true,
        ncyBreadcrumb: {
          label: '{{"modules.forensic-license-plate.breadcrumbSearch" | translate}}',
        },
      })
      .state('member.customer.show.project.forensicLicensePlates.watchlists', {
        url: '/watchlists',
        template: `<new-front-container path="'license-plates/watchlists'"></new-front-container>`,
        authenticated: true,
        ncyBreadcrumb: {
          label: '{{"modules.forensic-license-plate.breadcrumbWatchlists" | translate}}',
        },
      })
      .state('member.customer.show.project.forensicLicensePlates.blacklistDetections', {
        url: '/blacklist-detections',
        component: 'forensicLicensePlatesBlacklistDetections',
        authenticated: true,
        resolve: {
          module: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/editors/jsoneditor.min.js',
                window.assetsPath + `/css/editors-${style}.css`,
                window.assetsPath + '/js/app/event-management.module.min.js',
                window.assetsPath + `/css/event-management-${style}.css`,
              ]);
            },
          ],
          adminUsers: [
            'OrganizationService',
            'user',
            function (OrganizationService, user) {
              return OrganizationService.getUsers({ id: user.varId });
            },
          ],
          users: [
            'Customer',
            '$transition$',
            'AppUtils',
            function (Customer, $transition$, utils) {
              let params = $transition$.params();
              return Customer.managers({ id: params.customerId }).$promise.catch((err) => {
                throw utils.getHTTPError(err, {
                  redirectTo: 'member.customer.show.home',
                  params: { customerId: params.customerId },
                });
              });
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"modules.forensic-license-plate.breadcrumbBlacklistDetections" | translate}}',
        },
      });
  }
})();
